import { useEffect, useState } from "react";
import { getWidgets } from "../../../../../action/masters/widgetActionCreator";
import { connect, useDispatch } from "react-redux";
import { ICampusEvents } from "../../../../../models/dashboard/staffDashboard";
import { setWidgets } from "../../../../../store/slices/master/widgetSlice";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { IWidgets } from "../../../../../models/master/widgets";
import { baseURL } from "../../../../../constants/commonConstants";

const CampusEventsViewAll = (props: ICampusEvents) => {
  const { getCampusEvents, campusEvents } = props;
  const [allEvents, setAllEvents] = useState<IWidgets[]>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setWidgets([]));
    getCampusEvents(pageBlockId.campusEvents, undefined);
  }, []);

  useEffect(() => {
    setAllEvents(campusEvents);
  }, [campusEvents]);

  useEffect(() => {
    return () => {
      dispatch(setWidgets([]));
    };
  }, []);

  return (
    <>
      <div className="widgets">
        <div className="title">
          <h2>All Campus Events</h2>
        </div>
        <div className="card-wrap">
          <div className="row">
            {allEvents
              ?.filter((alert: IWidgets) => alert.displayOrNot)
              .map((alert: IWidgets) => (
                <div className="col-md-12 mb-3" key={alert.id}>
                  <div className="resourcecard icon-visibility">
                    <a href={alert.url} target="_blank" className="h-100">
                      <div className="img">
                        <img src={baseURL + alert.image} alt="" />
                      </div>
                      <div className="dtls">
                        <h3 className="para-hide-1">{alert.name}</h3>
                        <p className="para-hide-2">{alert.description}</p>
                      </div>
                      <span>
                        <img src="/assets/images/icon/arrow-right.svg" alt="" />
                      </span>
                    </a>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getCampusEvents: (pageBlockId?: number, noOfItems?: number) =>
    getWidgets(undefined, pageBlockId, undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    campusEvents: state.widget.quickLinkWidget,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CampusEventsViewAll);
